<template>
	<div class="world-quiz-feedback stage" :style="{ 'background-image': backgroundImage }">

		<div class="world-quiz-feedback__background-overlay background-overlay">

			<div class="header__container">
				<div class="header" style="position: relative;">
					{{feedback.header}}
				</div>
				<div class="subHeader" style="position: relative;">
					{{feedback.subheader}}
				</div>
				<div class="text text-top" style="position: relative;">
					{{feedback.feedbacktext}}
				</div>
			</div>
			<div class="explanation mainTitle" style="position: relative"/>

			<div class="panel" style="position: relative;">

				<table class="inventory">
					<tr v-for="(name, i) in feedbackData.names">
	                    <!--td class="icon-cell">
							<div class="feedback__icon">
								<div class="feedback__icon__text">{{Math.round((feedbackData.correctScores[i]/feedbackData.totalScores)*100)}}%</div>
								<img :src="baseUrl + questionData.items[i].visual"/>
							</div>
						</td-->
						<td class="icon-cell">
							<div class="draggable-holder" style="width: 100%;">
								<div id="Industrie" class="draggable ui-draggable ui-draggable-handle">
									<div class="icon">
                                        <img :src="baseUrl + questionData.items[i].visual"/>
                                        <div class="feedback__icon__text">{{Math.round((feedbackData.correctScores[i]/feedbackData.totalScores)*100)}}%</div>
                                    </div>
                                </div>
                            </div>
						</td>
						
						<td class="feedback__name">
							<b>{{feedbackData.names[i].replace(/_/g," ")}} (Jij had {{Math.round((feedbackData.currentScores[i]/feedbackData.totalScores)*100)}}%)</b>
	                        <p>{{feedbackArray[i]}}</p>
	                    </td>
	                    <!--td class="feedback__score">
							
						</td-->
					</tr>
				</table>

			</div>

			<div class="text text-bottom" style="position: relative">
				{{roundData.questions.feedback[0].feedbacktext}}
			</div>
		</div>

	</div>
</template>

<script>

	import Lottie from '../../../Lottie.vue';
	import { url} from '../../../../const/base';
	import {mapGetters , mapActions} from 'vuex';

	export default {

		components:{
			Lottie,
		},

		beforeMount(){
			this.findCorrectFeedback();
			this.setFeedback();
		},

		mounted(){
			setTimeout(()=>{
				this.setNextButtonAction(this.lastRound ? this.toNextStage : this.toNextRound).then(()=>{
					this.showNextButton({"btn":true , "btn-progres":true , "btn-progres-utrecht-whiteLine":true});
				});
			},500);

			this.increaseTransitorScore(this.feedbackData.transitors);

		},

		data(){
			return {
				baseUrl : url,
				selectedFeedbackIndex: -1,
				feedbackArray : []
			}
		},
		methods:{
			...mapActions([
				"setNextButtonAction",
				"showNextButton",
				"toNextStage",
				"toNextRound",
				"increaseTransitorScore",
			]),

			findCorrectFeedback(){

				console.log(this.feedbackData.totalScores*10);

				if(this.roundData == null || this.roundData.questions.feedback == null) return;
				let index=0;
				for(let i = 0 ; i < this.roundData.questions.feedback.length ; i++){
					let fb = this.roundData.questions.feedback[i];
					if(+fb.score <= (this.feedbackData.totalScores*10) && +fb.score >= +this.roundData.questions.feedback[index].score){
						index = i;
					}
				}
				this.selectedFeedbackIndex = index;
			},

			setFeedback(){
				for(let i = 0 ; i < this.questionData.items.length; i++){
					let item = this.questionData.items[i];
					let text = "";
					if(this.feedbackData.currentScores[i] > +this.feedbackData.correctScores[i])
						text = item.text_high;
					else if(this.feedbackData.currentScores[i] < +this.feedbackData.correctScores[i])
						text = item.text_low;
					else
						text = item.text_correct;

					let percentage = Math.floor((this.feedbackData.correctScores[i] / this.questionData.total_items) * 100);

					var text = text.replace("[%]", percentage+"%");
					this.feedbackArray.push(text);
				}


			}
		},
		computed:{
			...mapGetters([
				"questionData",
				"feedbackData",
				"lastRound",
				'roundData',
			]),

			feedback(){
				return this.selectedFeedbackIndex >= 0 ?this.roundData.questions.feedback[this.selectedFeedbackIndex] : {header:"Undefined header",subheader:"Undefined subheader",feedbacktext:"Undefined text",visual:"undefined"};
			},

			backgroundImage: function() {
		        return 'url('+ this.baseUrl + this.roundData.questions.question_background + ')';
		    },
		},

	}
</script>


// WEBPACK FOOTER //
// src/components/minigames/feedback/world/Index.vue